module.exports = __webpack_public_path__ + "img/microscope-duotone.d2b3db63.svg";